import { render, staticRenderFns } from "./AllocationDialog.vue?vue&type=template&id=94542002&scoped=true"
import script from "./AllocationDialog.vue?vue&type=script&lang=js"
export * from "./AllocationDialog.vue?vue&type=script&lang=js"
import style0 from "./AllocationDialog.vue?vue&type=style&index=0&id=94542002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94542002",
  null
  
)

export default component.exports